(() => {
  'use strict';
  function init(root) {
    if (root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    root.classList.add('catalog-js');
    const dialog = root.querySelector('.catalog-quick-dialog');
    const content = root.querySelector('[data-quick-content]');
    const status = root.querySelector('[data-catalog-status]');
    let opener, loading;
    root.querySelector('[data-catalog-sort]')?.addEventListener('change', event => {
      event.target.form.requestSubmit();
    });
    root.querySelector('[data-catalog-filters]')?.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(event.target.action, location.origin);
      for (const [name, value] of new FormData(event.target)) {
        if (String(value).trim()) url.searchParams.append(name, value);
      }
      location.assign(url.href);
    });
    function close() { dialog?.close(); }
    root.querySelector('[data-close-quick]')?.addEventListener('click', close);
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
    });
    dialog?.addEventListener('close', () => {
      loading?.abort();
      opener?.focus();
    });
    root.addEventListener('click', async event => {
      const trigger = event.target.closest('[data-quick-add-url]');
      if (!trigger || !dialog || !content) return;
      event.preventDefault();
      if (!dialog.contains(trigger)) opener = trigger;
      loading?.abort();
      loading = new AbortController();
      content.replaceChildren();
      const message = document.createElement('p');
      message.setAttribute('role', 'status');
      message.textContent = 'Chargement des options…';
      content.append(message);
      if (!dialog.open) dialog.showModal();
      try {
        const url = new URL(trigger.dataset.quickAddUrl, location.origin);
        url.searchParams.set('section_id', 'quick-add');
        const response = await fetch(url, {signal: loading.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Impossible de charger les options.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const product = html.querySelector('.catalog-quick-product');
        if (!product) throw new Error('Les options de cette pièce ne sont pas disponibles.');
        content.replaceChildren(product);
        content.querySelector('[data-variant-select]')?.focus();
      } catch (error) {
        if (error.name === 'AbortError') return;
        message.textContent = error.message;
        const link = document.createElement('a');
        link.href = trigger.dataset.quickAddUrl;
        link.className = 'catalog-product-details';
        link.textContent = 'VOIR LA PIÈCE →';
        content.append(link);
      }
    });
    root.addEventListener('change', event => {
      const select = event.target.closest('[data-variant-select]');
      if (!select) return;
      const option = select.selectedOptions[0];
      const form = select.form;
      const quantity = form.querySelector('[data-variant-quantity]');
      const valid = Boolean(option?.value) && !option.disabled;
      form.querySelector('[data-variant-submit]').disabled = !valid;
      if (!valid) return;
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.increment || '1';
      quantity.value = quantity.min;
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const price = form.closest('.catalog-quick-info').querySelector('[data-variant-price]');
      price.textContent = option.dataset.price;
      if (option.dataset.compare) {
        const compare = document.createElement('s');
        compare.className = 'catalog-quick-price-compare';
        compare.textContent = option.dataset.compare;
        price.append(compare);
      }
    });
    root.addEventListener('submit', async event => {
      const form = event.target.closest('[data-quick-add-form]');
      if (!form) return;
      event.preventDefault();
      if (form.dataset.pending || !form.reportValidity()) return;
      const fields = new FormData(form);
      const id = String(fields.get('id') || '');
      const quantity = Number(fields.get('quantity'));
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) return;
      const button = form.querySelector('button[type="submit"]');
      const target = form.closest('.catalog-quick-info')?.querySelector('[data-quick-status]') || status;
      form.dataset.pending = 'true';
      form.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (target) target.textContent = 'Ajout en cours…';
      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id, quantity}]})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Cette pièce ne peut pas être ajoutée.');
        if (target) {
          target.textContent = 'Pièce ajoutée au panier.';
          const link = document.createElement('a');
          link.href = root.dataset.cartUrl.replace(/\.js$/, '');
          link.textContent = 'Voir le panier';
          target.append(link);
        }
        try {
          const cartResponse = await fetch(root.dataset.cartUrl, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.cart-link').forEach(link => {
              let badge = link.querySelector('.cart-count');
              if (cart.item_count > 0) {
                if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.append(badge); }
                badge.textContent = cart.item_count;
              } else badge?.remove();
              link.setAttribute('aria-label', 'Panier (' + cart.item_count + ')');
            });
            document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart}}));
          }
        } catch { /* L'ajout reste réussi si le rafraîchissement du compteur échoue. */ }
      } catch (error) {
        if (target) target.textContent = error.message || 'Impossible d’ajouter cette pièce. Réessayez.';
      } finally {
        delete form.dataset.pending;
        form.removeAttribute('aria-busy');
        button.disabled = false;
      }
    });
  }
  function mount() { document.querySelectorAll('[data-catalog]').forEach(init); }
  mount();
  document.addEventListener('shopify:section:load', mount);
})();